import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  makeStyles
} from "@material-ui/core";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
  dialog: {
    minWidth: 400,
  },
  content: {
    padding: theme.spacing(3),
  },
  title: {
    fontWeight: "bold",
    marginBottom: theme.spacing(2),
    color: theme.palette.primary.main,
  },
  message: {
    marginBottom: theme.spacing(2),
    lineHeight: 1.6,
  },
  aiWarning: {
    backgroundColor: theme.palette.warning.light,
    color: theme.palette.warning.contrastText,
    padding: theme.spacing(2),
    borderRadius: theme.spacing(1),
    marginBottom: theme.spacing(2),
    border: `1px solid ${theme.palette.warning.main}`,
  },
  promptInfo: {
    fontWeight: "bold",
    color: theme.palette.secondary.main,
  },
  actions: {
    padding: theme.spacing(2),
    justifyContent: "center",
  },
  confirmButton: {
    marginLeft: theme.spacing(1),
  },
}));

const TransferConfirmationModal = ({
  open,
  onClose,
  onConfirm,
  queueName,
  hasAI,
  automationType, // ✅ "prompt" | "integration" | "chatbot" | null
  automationName, // ✅ Nombre del prompt/integración/chatbot
  promptName,
  loading = false
}) => {
  const classes = useStyles();

  // ✅ Logs de debugging removidos - funcionalidad verificada

  const handleConfirm = () => {
    onConfirm();
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      maxWidth="sm"
      fullWidth
      className={classes.dialog}
    >
      <DialogTitle className={classes.title}>
        {i18n.t("transferConfirmationModal.title")}
      </DialogTitle>

      <DialogContent className={classes.content}>
        {hasAI ? (
          <Box>
            <Box className={classes.aiWarning}>
              <Typography variant="body1" className={classes.message}>
                {(() => {
                  const queueNameValue = queueName || "Departamento";
                  // ✅ MOSTRAR MENSAJE SEGÚN TIPO DE AUTOMATIZACIÓN
                  if (automationType === "flowbuilder") {
                    return `El departamento ${queueNameValue} tiene activado AGENTE IA`;
                  } else if (automationType === "prompt") {
                    return `El departamento ${queueNameValue} tiene activado AGENTE IA`;
                  } else if (automationType === "chatbot") {
                    return `El departamento ${queueNameValue} tiene activado AGENTE IA`;
                  } else if (automationType === "integration") {
                    return `El departamento ${queueNameValue} tiene activado AGENTE IA`;
                  } else {
                    // Fallback genérico
                    const translatedText = i18n.t("transferConfirmationModal.aiWarning");
                    return translatedText.replace('{queueName}', queueNameValue);
                  }
                })()}
              </Typography>
              {/* ✅ MOSTRAR INFORMACIÓN ESPECÍFICA SEGÚN TIPO */}
              {automationType === "flowbuilder" && automationName && (
                <Typography variant="body2" className={classes.promptInfo}>
                  FlowBuilder: {automationName}
                </Typography>
              )}
              {automationType === "prompt" && promptName && (
                <Typography variant="body2" className={classes.promptInfo}>
                  Prompt: {promptName}
                </Typography>
              )}
              {automationType === "chatbot" && automationName && (
                <Typography variant="body2" className={classes.promptInfo}>
                  Chatbot: {automationName}
                </Typography>
              )}
              {automationType === "integration" && automationName && (
                <Typography variant="body2" className={classes.promptInfo}>
                  Integración: {automationName}
                </Typography>
              )}
            </Box>
            <Typography variant="body1" className={classes.message}>
              {i18n.t("transferConfirmationModal.aiQuestion")}
            </Typography>
          </Box>
        ) : (
          <Typography variant="body1" className={classes.message}>
            {(() => {
              const queueNameValue = queueName || "Departamento";
              // ✅ SOLUCIÓN: Reemplazo manual ya que i18n no funciona correctamente
              const translatedText = i18n.t("transferConfirmationModal.humanQuestion");
              const finalText = translatedText.replace('{queueName}', queueNameValue);
              
              // ✅ Log de debugging removido
              
              return finalText;
            })()}
          </Typography>
        )}
      </DialogContent>

      <DialogActions className={classes.actions}>
        <Button
          onClick={handleCancel}
          color="secondary"
          disabled={loading}
        >
          {i18n.t("transferConfirmationModal.cancel")}
        </Button>
        <Button
          onClick={handleConfirm}
          color="primary"
          variant="contained"
          disabled={loading}
          className={classes.confirmButton}
        >
          {loading 
            ? i18n.t("transferConfirmationModal.transferring") 
            : i18n.t("transferConfirmationModal.confirm")
          }
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TransferConfirmationModal;
